import React from 'react'
import NotFoundImage from "../../assets/images/404-error.jpg"
import { Link } from 'react-router-dom'
import { config } from '../pages/config'

const NotFound = () => {
    return (
        <div>
            <div className='container'>
                <div className=' mt-5 mb-5 d-flex gap-3 align-items-center'>
                    <div className='not-found'>
                        <h1 className='mb-2'>Ooops ...</h1>
                        <h3 className='mb-2'>Page Not Found</h3>
                        <p className='col-md-10'>The page you are looking for doesn't exist or an another error occured, go back to home page</p>
                        <div class="btn-part mt-5">
                            <Link to={`${config.appUrl}`} class="readon about border-0" >
                                <span class="btn-text">Go Back</span>
                            </Link>
                        </div>
                    </div>
                    <img src={NotFoundImage} alt='No Image Found' />
                </div>
            </div>
        </div>
    )
}

export default NotFound
